import { useParams } from "react-router-dom";
import InboxPage from "./inbox.page";

export const InboxView = () => {
    const { conversationId } = useParams();

    return (
        <InboxPage jobId={conversationId} />
    );
};
